import { RequestMethod } from './apiClient'
import { detectPlatform } from '@/shared/lib'

export const createRequestData = (
    requestMethod: RequestMethod,
    profileId?: string,
    authToken?: string | null,
    requestBody?: string,
    requestHeaders?: object
) => {
    const requestData = {
        method: requestMethod,
        body: requestBody ? requestBody : null,
        headers: authToken
            ? createAuthRequestHeaders(authToken, requestHeaders)
            : createRequestHeaders(requestHeaders),
    }

    return requestData
}

export const createAuthRequestHeaders = (
    authToken: string,
    headers?: object
) => {
    const authRequestHeaders = {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${authToken}`,
        Platform: detectPlatform(navigator.userAgent),
        ...headers,
    }
    return authRequestHeaders
}

export const createRequestHeaders = (headers?: object) => {
    const requestHeaders = {
        'Content-type': 'application/json; charset=UTF-8',
        Platform: detectPlatform(navigator.userAgent),
        ...headers,
    }

    return requestHeaders
}
